import { GlobalState } from '../createStore';

export const groupingsDomain = (state: GlobalState) => state.groupingArtworks;
